function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M501.3,199.6c-1.7-5.2-6.2-9-11.6-9.8l-152.5-22.2L268.9,29.4c-2.4-4.9-7.4-8-12.9-8c-5.5,0-10.5,3.1-12.9,8 l-68.2,138.2L22.3,189.7c-5.4,0.8-9.9,4.6-11.6,9.8c-1.7,5.2-0.3,10.9,3.6,14.8l110.4,107.6l-26,151.9c-0.9,5.4,1.3,10.9,5.7,14.1 c2.5,1.8,5.5,2.8,8.5,2.8c2.3,0,4.6-0.5,6.7-1.7L256,417.3L392.4,489c4.9,2.6,10.7,2.1,15.2-1.1c4.4-3.2,6.7-8.7,5.7-14.1 l-26.1-151.9l110.4-107.6C501.6,210.5,503,204.8,501.3,199.6z"
});

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.d334155e.svg";
export { ForwardRef as ReactComponent };